import React from "react";
import "../assets/css/Logo.css";

export default function Logo() {
  return (
    <>
      <div className="Logo">
        <div className="Logo-O"></div>
        <span className="Logo-span span1"></span>
        <span className="Logo-span span2"></span>
        <span className="Logo-span span3"></span>
        <span className="Logo-span span4"></span>
        <span className="Logo-span span5"></span>
        <p className="Logo-p p-name">ahuel</p>
        <p className="Logo-p p-lastName">rselli</p>
      </div>
    </>
  );
}
